module.exports = __webpack_public_path__ + "02e7804a546c646682e4ae11f7cc9e58.png";